export const EMPTY_PROJECT_CODE = '0000000000'
export const EMPTY_SUB_SUBJECT_ID = -1
export const TEXT_MAX_LENGTH = 500
export const DEFAULT_PAGE_SIZE = 50
